<template>
  <v-flex xs12>
    <v-layout row align-center justify-space-between>
        <v-flex xs12 class="text-xs-center caption" @click="jumpTo(wo)">
            {{wo.clientCode}} {{wo.type}}
        </v-flex>
    </v-layout>
    </v-flex>
</template>

<script>

import moment from 'moment'
import axios from 'axios'
import myMixins from '../mixins/myMixins'

export default {
  props: ['wo'],
  mixins: [myMixins],
  data () {
    return {
      showDatePicker: false,
      picker: new Date().toISOString().substr(0, 10)
    }
  },
  methods: {
    jumpTo (wo) {
      this.$store.state.client = this.$store.state.clientsByCode[wo.clientCode]
      this.$router.push({
        path: '/workorder',
        query: {
          id: wo.id
        }
      })
    },
    goto () {
      this.$store.state.client = this.scp.Client
      this.$router.push({
        path: '/workorder',
        query: {
          id: this.scp.WorkOrder.id
        }
      })
    }
  }
}
</script>
<style>
</style>
